import { render, staticRenderFns } from "./PutDetail.vue?vue&type=template&id=70db68df&scoped=true&"
import script from "./PutDetail.vue?vue&type=script&lang=js&"
export * from "./PutDetail.vue?vue&type=script&lang=js&"
import style0 from "./PutDetail.vue?vue&type=style&index=0&id=70db68df&prod&lang=scss&"
import style1 from "./PutDetail.vue?vue&type=style&index=1&id=70db68df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db68df",
  null
  
)

export default component.exports